import { render } from "./UpcomingEvents.vue?vue&type=template&id=2d7558a7&scoped=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"

import "./UpcomingEvents.vue?vue&type=style&index=0&id=2d7558a7&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7558a7"]])

export default __exports__